import React from 'react'
import s from '../../address/AddressMainContent.less'
import GeoentitiesAtAddressPicker from '../../address/GeoentitiesAtAddressPicker'
import { AdDesktopAddress } from '../../advertising/InlineDesktopAdBanner'
import { AdMobileBannerAddress } from '../../advertising/InlineMobileAdBanner'
import Footer from '../../footer/Footer'
import ZoneContent from './ZoneContent'
import BestGeoentitiesAround from '../../address/BestGeoentitiesAround'
import {
  BEST_GEOENTITIES_SUBCATEGORY_HOTEL,
  BEST_GEOENTITIES_SUBCATEGORY_RESTAURANT,
} from '../../address/BestGeoentitiesAround.utils'
import AddressBlogLinks from '../../address/AddressBlogLinks'
import AddressStructuredData from '../../address/AddressStructuredData'

const ZoneMainContent = ({ titleContent }) => {
  return (
    <>
      <div className={s.addressMainContent}>
        <AddressStructuredData />
        <ZoneContent titleContent={titleContent} />
        <AdDesktopAddress />
        <div>
          {/* div necessary here for css first-child */}
          <BestGeoentitiesAround subcategory={BEST_GEOENTITIES_SUBCATEGORY_HOTEL} />
          <BestGeoentitiesAround subcategory={BEST_GEOENTITIES_SUBCATEGORY_RESTAURANT} />
          <AddressBlogLinks />
        </div>
        <GeoentitiesAtAddressPicker />
        <AdMobileBannerAddress />
      </div>
      <Footer />
    </>
  )
}

export default ZoneMainContent
